"use server";

import { apply } from "@/lib/applications";

export type ApplyState = { error?: string; done?: boolean };

const str = (v: FormDataEntryValue | null) => (typeof v === "string" ? v.trim() : "");

export async function applyAction(_prev: ApplyState, form: FormData): Promise<ApplyState> {
  const kind = str(form.get("kind")) === "trainee" ? "trainee" : "consultant";
  const r = await apply({
    kind,
    name: str(form.get("name")),
    email: str(form.get("email")),
    focus: str(form.get("focus")),
    links: str(form.get("links")),
    statement: str(form.get("statement")),
  });
  return r.ok ? { done: true } : { error: r.error };
}
